(function () {
  if (window.Shopify && Shopify.designMode) return;
  try {
    // ------------ CONFIG ------------
    // Define the traffic-split map. Each "test" has a slug, one or more source matchers,
    // and one or more variants (each with a label, weight, and absolute or path URL).
    // Example: split traffic from /products/foo to either /products/foo (control) or /products/foo-new (variant).
    var TESTS = [
      {
        slug: "Chuck_bucket_LP",
        sources: [
            function (p) {
                p = p.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '');
                if (p.length > 1 && p.endsWith('/')) p = p.slice(0, -1);
                return p === '/pages/chuck-bucket-ski-rack';
            }
        ],
        variants: [
          { label: "original",     weight: 0.50, url: "/pages/chuck-bucket-ski-rack" },
          { label: "new",   weight: 0.50, url: "/pages/chuck-bucket-ski-rack" }
        ]
      }
    ];

    // Global override enablement (e.g., ?aboff=1 disables all tests)
    var GLOBAL_OFF_PARAM = "aboff";

    // Loop-guard param to avoid re-redirecting forever
    var LOOP_MARK = "ablp"; // "ab landing pass"

    // Per-test session cookie prefix
    var COOKIE_PREFIX = "ab_route_";

    // Optional: custom event name
    var HEAP_EXPOSURE_EVENT = "AB Exposure - Route Split";

    // ------------ HELPERS ------------
    function nowPath() {
    var p = location.pathname;
    return p.length > 1 && p.endsWith("/") ? p.slice(0, -1) : p;
    }
    function asURL(u) {
      try { return new URL(u, location.origin); } catch (e) { return null; }
    }
    function isRegexString(s) { return typeof s === "string" && s.startsWith("^") && s.endsWith("$"); }
    function matchSource(matcher, path) {
      if (typeof matcher === "function") return !!matcher(path);
      if (isRegexString(matcher)) return new RegExp(matcher).test(path + location.search);
      if (typeof matcher === "string") {
        // match literal path only (ignore query)
        var lit = matcher.split("?")[0];
        return path === lit;
      }
      return false;
    }
    function findTestForPath(path) {
      for (var i = 0; i < TESTS.length; i++) {
        var t = TESTS[i];
        for (var j = 0; j < t.sources.length; j++) {
          if (matchSource(t.sources[j], path)) return t;
        }
      }
      return null;
    }
    function setSessionCookie(name, value) {
      document.cookie = name + "=" + encodeURIComponent(value) + "; path=/; SameSite=Lax";
    }
    function getCookie(name) {
      return document.cookie.split("; ").reduce(function (val, c) {
        var i = c.indexOf("="); var k = c.substring(0, i); var v = c.substring(i + 1);
        return k === name ? decodeURIComponent(v) : val;
      }, "");
    }
    function weightedPick(variants) {
      var total = variants.reduce((s, v) => s + (v.weight || 0), 0);
      if (!total) return variants[0];
      var r = Math.random() * total, acc = 0;
      for (var i = 0; i < variants.length; i++) {
        acc += variants[i].weight || 0;
        if (r <= acc) return variants[i];
      }
      return variants[variants.length - 1];
    }
    function samePath(a, b) {
      var A = asURL(a), B = asURL(b);
      return A && B && A.pathname === B.pathname;
    }
    function mergeParamsPreservingUTMs(destUrl, fromUrl) {
      // Copy all query params from the *current* URL into the destination unless already present
      var keep = new URL(destUrl.toString());
      fromUrl.searchParams.forEach(function (val, key) {
        if (key === LOOP_MARK) return; // never propagate loop guard forward
        if (!keep.searchParams.has(key)) keep.searchParams.set(key, val);
      });
      // Add loop guard
      keep.searchParams.set(LOOP_MARK, "1");
      return keep;
    }
    function getOverride() {
      // supports ?abtest=<slug>:<variantLabel> OR ?abtest=<slug>:off OR ?aboff=1 (global)
      var url = new URL(location.href);
      var off = url.searchParams.get(GLOBAL_OFF_PARAM);
      if (off === "1" || off === "true") return { globalOff: true };

      var ab = url.searchParams.get("abtest");
      if (!ab) return null;
      // Examples: abtest=pdp_foo_title_test:new_title  |  abtest=pdp_foo_title_test:off
      var parts = ab.split(":");
      if (parts.length !== 2) return null;
      return { slug: parts[0], variant: parts[1] };
    }

    // ------------ EARLY EXIT / PARSE ------------
    var currentPath = nowPath();
    var currentUrl = new URL(location.href);
    var override = getOverride();
    if (override && override.globalOff) return;

    // If this page is a source for some test, we may choose/redirect
    var test = findTestForPath(currentPath);

    // ------------ DECIDE VARIANT (per-session per test) ------------
    var cookieName = COOKIE_PREFIX + test.slug;
    var chosenVariantLabel = getCookie(cookieName);

    // Per-test QA override
    if (override && override.slug === test.slug) {
      if (override.variant === "off") {
        // Disable this test but still stamp "disabled" so we can see QA sessions
        return;
      }
      chosenVariantLabel = override.variant;
      setSessionCookie(cookieName, chosenVariantLabel);
    }

    if (!chosenVariantLabel) {
      chosenVariantLabel = (weightedPick(test.variants) || test.variants[0]).label;
      setSessionCookie(cookieName, chosenVariantLabel);
    }

    // Find the destination URL for the chosen label
    var dest = test.variants.find(function (v) { return v.label === chosenVariantLabel; });
    if (!dest) {
      // Fallback to first variant if label missing/mistyped
      dest = test.variants[0];
      chosenVariantLabel = dest.label;
      setSessionCookie(cookieName, chosenVariantLabel);
    }

    var destUrl = asURL(dest.url);
    if (!destUrl) return; // bad config; fail safely

    // ------------ TRACK & REDIRECT LOGIC ------------
    // If we’re already on the destination path (control often equals source), just stamp Heap and stop.
    if (samePath(destUrl, location.href)) {
      return;
    }

    // Avoid loops (if this reload already set the guard, don’t stamp/redirect again)
    if (currentUrl.searchParams.get(LOOP_MARK) === "1") {
      // We are on a source with a loop mark — do nothing further
      return;
    }

    // Preserve UTMs and existing params when jumping to destination
    var finalUrl = mergeParamsPreservingUTMs(destUrl, currentUrl);

    // Redirect
    location.replace(finalUrl.toString());
  } catch (e) {
    console && console.warn && console.warn("AB route-split error:", e);
  }
})();